import axios from "axios";
import { buildApiUrl } from "./api";

const localReadBaseUrl = "/engineering-intelligence";

export function resolveEngineeringIntelligenceReadBaseUrl(environment = process.env.NODE_ENV) {
    return (environment === "development"
        ? (process.env.REACT_APP_ENGINEERING_INTELLIGENCE_URL || localReadBaseUrl)
        : buildApiUrl("/engineering-intelligence")).replace(/\/$/, "");
}

export const engineeringIntelligenceBaseUrl = resolveEngineeringIntelligenceReadBaseUrl();

export async function fetchEngineeringEvidence() {
    const { data } = await axios.get(process.env.NODE_ENV === "development"
        ? `${engineeringIntelligenceBaseUrl}/api/evidence.json`
        : `${engineeringIntelligenceBaseUrl}/evidence`, { withCredentials: true });
    if (!data || typeof data !== "object" || !data.command_center || typeof data.command_center !== "object") throw new Error("malformed_engineering_intelligence_response");
    return data;
}
